module.exports = __webpack_public_path__ + "static/follow-me-e04cc769165fc5be7fb41d10bc1529d6.png";